import type { PuzzleDefinition } from '@nonogram/shared';
import { getHttpServerUrl } from './server-url.js';
import { fetchJson } from './http-errors.js';

/** Shares a puzzle by an unlisted link (POST /api/shared-puzzles). Returns its id. */
export async function sharePuzzle(
  puzzle: Pick<PuzzleDefinition, 'name' | 'rows' | 'columns' | 'colors' | 'solution' | 'givens'> & { author?: string },
  baseUrl: string = getHttpServerUrl(),
  fetchImpl: typeof fetch = globalThis.fetch.bind(globalThis),
): Promise<string> {
  const result = await fetchJson<{ id: string }>(fetchImpl, `${baseUrl}/api/shared-puzzles`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: puzzle.name,
      rows: puzzle.rows,
      columns: puzzle.columns,
      colors: puzzle.colors,
      solution: puzzle.solution,
      ...(puzzle.givens ? { givens: puzzle.givens } : {}),
      ...(puzzle.author ? { author: puzzle.author } : {}),
    }),
  });
  return result.id;
}
